module.exports = __webpack_public_path__ + "static/img/1001_small.1c4b6ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1001_small.png
// module id = Lv/P
// module chunks = 1